import { render } from "./PageLegend.vue?vue&type=template&id=a2ad5a52&scoped=true"
import script from "./PageLegend.vue?vue&type=script&lang=js"
export * from "./PageLegend.vue?vue&type=script&lang=js"

import "./PageLegend.vue?vue&type=style&index=0&id=a2ad5a52&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ad5a52"]])

export default __exports__